import { useContext } from 'react'
import { Layout } from '../widgets'
import { FeatureFlagContext } from '../widgets/FeatureFlagContext'

const ConversationsView = (props) => {

  const { getFlagValue } = useContext(FeatureFlagContext)

  if (!getFlagValue('showDMs')) {
    return <Layout>
        <div className='welcome-title'>404</div>
        <div>There's nothing here</div>
    </Layout>
  }

  return <div className='body-container'>
      <Layout>
        <Layout.Header>Messages</Layout.Header>

          <div>
            <p>hello world, this is a WIP messages view</p>
          </div>

      </Layout>
    </div>

}

export default ConversationsView
